import qs from "query-string";

export const paramsSerializer = (params) => {
  return qs.stringify(params);
};
